var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{staticClass:"my-app",staticStyle:{"background-color":"var(--grisclair)"}},[(_vm.$route.name !== 'code-access' && _vm.$route.name !== 'connexion')?_c('nav-bar'):_vm._e(),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }